import React, { Component, PropTypes } from 'react'

import { getProperty, filterObject } from '../utils'
import { Loading } from '../misc'
import { Boolean, TextInput } from '../ui'

export default class SoundMixerAccessories extends Component {
    static propTypes = {
        crewType: PropTypes.string.isRequired,
        crew_uuid: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
    }

    _updateValueAndSendPatchRequest = (data) => {
        this.props.updateValue(data)
        this._sendPatchRequest(data)
    }

    _sendPatchRequest = (data = this.props.data) => {
        const newData = filterObject(
            data,
            [
                'breakout_cable',
                'breakout_cable_quantity',
                'timecode_slate',
                'timecode_slate_make',
                'timecode_slate_model',
                'dummy_slate',
                'tablet_slate',
            ],
        )

        this.props.gearActions.patchGear(newData, this.props.crew_uuid, this.props.crewType)
    }

    render() {
        if (! this.props.data) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        let breakoutQuantityField = null
        let timecodeSlateMake = null
        let timecodeSlateModel = null

        if (getProperty(this.props.data, 'breakout_cable', false) === true) {
            breakoutQuantityField = (
                <TextInput
                    error={ errors.breakout_cable_quantity }
                    handleBlur={ this._sendPatchRequest }
                    name="breakout_cable_quantity"
                    placeholder="Enter total owned"
                    type="number"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'breakout_cable_quantity') }
                />
            )
        }

        if (getProperty(this.props.data, 'timecode_slate', false) === true) {
            timecodeSlateMake = (
                <TextInput
                    error={ errors.timecode_slate_make }
                    handleBlur={ this._sendPatchRequest }
                    name="timecode_slate_make"
                    placeholder="Enter make"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'timecode_slate_make') }
                />
            )
            timecodeSlateModel = (
                <TextInput
                    error={ errors.timecode_slate_model }
                    handleBlur={ this._sendPatchRequest }
                    name="timecode_slate_model"
                    placeholder="Enter model"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'timecode_slate_model') }
                />
            )
        }

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Accessories
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        <Boolean
                            error={ errors.breakout_cable }
                            label="Breakout cable"
                            name="breakout_cable"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'breakout_cable') }
                        />
                        { breakoutQuantityField }
                        <Boolean
                            error={ errors.timecode_slate }
                            label="Smart/timecode slate"
                            name="timecode_slate"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'timecode_slate') }
                        />
                        { timecodeSlateMake }
                        { timecodeSlateModel }
                        <Boolean
                            error={ errors.dummy_slate }
                            label="Dummy slate"
                            name="dummy_slate"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'dummy_slate') }
                        />
                        <Boolean
                            error={ errors.tablet_slate }
                            label="Tablet slate"
                            name="tablet_slate"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'tablet_slate') }
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/sound_mixer_accessories.js